import React from "react";
import Wrapper from "./formErrorModal.styles";
import Modal from "../modal";
import { FooterButtons } from "../modal/footerButtons";
import { OutlineModalButton } from "../modal/modalButton";

export const FormErrorModal = (props) => (
  <Modal
    visible={props.visible}
    header="Unfortunately, something went wrong"
    size="extra-small"
    closeable
    onClose={props.close}
    footer={
      <FooterButtons>
        <OutlineModalButton
          onClick={props.close}
          id="closeErrorModal"
        >
          Cancel
        </OutlineModalButton>
        <OutlineModalButton
          onClick={props.restart}
          id="restartAppForm"
        >
          Restart
        </OutlineModalButton>
      </FooterButtons>
    }
  >
    <Wrapper>
      <div className="modalContent">
        <p className="label-text">We apologise for the inconvenience.</p>
        <p className="label-text">You can close this and try to submit by clicking next. If the problem persists you can
        try restarting the form OR <a href="/logout" title="Log out button">logging out</a> and try again.</p>
      </div>
    </Wrapper>
  </Modal>
);
